import React from 'react'
import { useParams } from 'react-router-dom'
import { Card, ViewHeader, Table, useGet, date, Help } from '@enkla-gui'
import { icons } from '@config'

export default function Message() {
  const { id } = useParams()
  const { data: message } = useGet({ endpoint: `api/contact/messages/${id}` })

  const getTypeLabel = (type) => {
    const labels = {
      entity: 'Objekt',
      company: 'Företag',
      lease: 'Uthyrning',
      tenant: 'Hyresgäst'
    }
    return labels[type] || type
  }

  return (
    <>
      <ViewHeader
        loading={!message}
        title={message?.subject || 'Meddelande'}
        subtitle='Skickat meddelande'
        icon={icons.email}
        return={{ link: '#!/contact/messages', title: 'Meddelandehistorik' }}
      />

      <div class='row'>
        <Card cols='col-8' loading={!message}>
          <div class='mb-3'>
            <label class='form-label text-muted'>Ämne</label>
            <div style={{ fontSize: '16px' }}>{message?.subject}</div>
          </div>
          <div class='mb-3'>
            <label class='form-label text-muted'>Innehåll</label>
            <div
              class='p-3'
              style={{ backgroundColor: '#f8f9fa', borderRadius: '4px', whiteSpace: 'pre-wrap' }}
              dangerouslySetInnerHTML={{ __html: message?.body }}
            />
          </div>
        </Card>
        <Card cols="col-4" title='Information' icon={icons.info} loading={!message}>
          <div class='mb-2'>
            <label class='text-muted d-block'>Skickat</label>
            <span>{message ? date.full(message.created_at) : ''}</span>
          </div>
          <div class='mb-2'>
            <label class='text-muted d-block'>Typ</label>
            <span>{message ? getTypeLabel(message.type) : ''}</span>
          </div>
          <div>
            <label class='text-muted d-block'>Antal mottagare</label>
            <span class='badge bg-primary'>{message?.recipients?.length || 0}</span>
          </div>
        </Card>
      </div>
      <div class="row">
        <Card
          title={`Mottagare (${message?.recipients?.length || 0})`}
          icon={icons.tenant}
          loading={!message}
        >
          {message?.recipients?.length > 0 ? (
            <Table
              rows={message.recipients}
              sorting={{}}
              functions={{
                status: (recipient) => {
                  if (!recipient.tenant) {
                    return <span class='badge bg-secondary'>Tidigare hyresgäst</span>
                  }
                  return <span class='badge bg-success'>Aktiv</span>
                },
                tenantLink: (recipient) => {
                  if (!recipient.tenant) {
                    return <span class='text-muted'>Tidigare hyresgäst</span>
                  }
                  return (
                    <a
                      href={`#!/tenant/${recipient.tenant.id}`}
                      class='text-decoration-none'
                    >
                      {recipient.tenant.name}
                    </a>
                  )
                },
                email: (recipient) => {
                  if (!recipient.tenant) {
                    return <span class='text-muted'>-</span>
                  }
                  return recipient.tenant.email
                }
              }}
              keys={['_this>function:tenantLink', '_this>function:email', '_this>function:status']}
              headers={[
                { value: 'Namn', sortable: false },
                { value: 'E-post', sortable: false },
                { value: 'Status', sortable: false, class: 'min' }
              ]}
            />
          ) : (
            <Help type='info'>
              <p>Inga mottagare registrerade för detta meddelande.</p>
            </Help>
          )}
        </Card>

      </div>
    </>
  )
}
